import { useLogto } from "@logto/react";
import { LOGTO_APPID } from "@src/utils/constants";
import { useCallback, useEffect, useState } from "react"


const useAutoLogin = () => {
  const { isAuthenticated, getAccessToken } = useLogto();
  const [isAuthExpired, setIsAuthExpired] = useState(false);
  const { signIn } = useLogto();
  const autoSignIn = useCallback((redirect?: string) => {
    localStorage.removeItem(`logto:${LOGTO_APPID}:accessToken`);
    localStorage.removeItem(`logto:${LOGTO_APPID}:idToken`);
    localStorage.removeItem(`logto:${LOGTO_APPID}:refreshToken`);
    sessionStorage.setItem('redirect', redirect ?? window.location.pathname);
    signIn(`${window.origin}/callback`);
  }, []);
  useEffect(() => {
    if (isAuthenticated) {
      getAccessToken().then(e => {
        if (!e) setIsAuthExpired(true); // Assuming
      });
    }
  },  [isAuthenticated]);
  return { autoSignIn, isAuthExpired };
}

export default useAutoLogin;
